import { useSharedState } from "hooks";
import { accountService } from "services";
import { openLoginModal } from "account/Login";
import { openRegisterModal } from "account/Register";
import { openProfileModal } from "account/Profile";

const useAuth = () => {
  const [user] = useSharedState(accountService.user);
  return {
    user,
    logout: accountService.logout,
    profile: openProfileModal,
    login: openLoginModal,
    register: openRegisterModal,
  };
};

export { useAuth };
